import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography, Box, IconButton, Tooltip } from "@material-ui/core";
import AccessibleIcon from "@material-ui/icons/Accessible";
import AccessibilityDialog from "../dialogs/AccessibilityDialog";
import * as customColors from "../../theme/customColors";

const useStyles = makeStyles(() => ({
  footer: {
    bottom: 0,
    left: 0,
    position: "fixed",
    right: 0,
    zIndex: 2
  },
  accessibilityButton: {
    color: customColors.white,
    left: 12,
    padding: 8,
    position: "absolute",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.12)"
    }
  },
  accessibilityIcon: {
    fontSize: 28
  }
}));

const Footer = () => {
  const classes = useStyles();
  const [isAccessibilityDialogOpen, setIsAccessibilityDialogOpen] = useState(false);

  return (
    <>
      <Box
        alignItems="center"
        bgcolor={customColors.darkBlue}
        className={classes.footer}
        color="white"
        display="flex"
        height="60px"
        justifyContent="center"
        width="100%"
      >
        <Tooltip title="נגישות">
          <IconButton
            aria-label="נגישות"
            className={classes.accessibilityButton}
            onClick={() => setIsAccessibilityDialogOpen(true)}
          >
            <AccessibleIcon className={classes.accessibilityIcon} />
          </IconButton>
        </Tooltip>
        <Typography>כל הזכויות שמורות לחברת ביטקס מיסוי מקרקעין בע"מ</Typography>
      </Box>
      {isAccessibilityDialogOpen ? (
        <AccessibilityDialog open onClose={() => setIsAccessibilityDialogOpen(false)} />
      ) : null}
    </>
  );
};

export default Footer;
